'use client';

import { useEffect, useState } from 'react';

/**
 * Use this hook to watch if a css media query is matched.
 *
 * @param {string} query Media Query to be matched.
 * @returns {boolean} Media query matches.
 */
export function useMediaQuery(query = '') {
  const [mediaMatches, setMediaMatches] = useState<boolean | undefined>();

  useEffect(() => {
    if (window) {
      const initialMedia = window.matchMedia(query);

      const handleMediaChange = () =>
        setMediaMatches(window.matchMedia(query).matches);

      window.addEventListener('resize', handleMediaChange);

      setMediaMatches(initialMedia.matches);
      return () => window.removeEventListener('resize', handleMediaChange);
    }
    return () => {};
  }, [query]);

  return mediaMatches;
}
